export default __webpack_public_path__ + "static/media/clock.131ebe2a.svg";